import { FC } from 'react'

import { MaterialIcon } from '@makyoapp/makyo-tw-ui'
import { Checkbox, SimpleInput } from '@makyoapp/makyo-ui'

import { BuilderComponentSetting } from '@/shared/builder'
import { SectionBackgroundGroupProps } from '@/shared/builder/default/section.default'
import { VariableSelectFieldSetting } from '@/pages/project-v2/layout/Editor/components/ComponentPanel/FieldSetting'

interface VideoBackgroundSelectProps {
  layer: SectionBackgroundGroupProps
  handleUpdate: (id: number, newValues: any) => Promise<void>
  id: string
  settingId: string
  videoSelectSettings: BuilderComponentSetting['videoSelectSettings']
}

export const VideoBackgroundSelect: FC<VideoBackgroundSelectProps> = ({
  handleUpdate,
  layer,
  id,
  settingId,
  videoSelectSettings,
}) => {
  return (
    <div className='space-y-4'>
      <VariableSelectFieldSetting
        id={id}
        settingId={settingId}
        variableSelectSettings={videoSelectSettings}
        value={layer.values.url}
        handleUpdate={(e: any) => handleUpdate(layer.id, { url: e })}
      />
      {layer.values.url && (
        <>
          <div className='flex gap-4'>
            <label className='flex items-center gap-2'>
              <Checkbox
                name='loop'
                checked={(layer.values.loop as boolean) ?? false}
                onClick={(e) => handleUpdate(layer.id, { loop: e })}
                label='Loop'
              />
            </label>
            <label className='flex items-center gap-2'>
              <Checkbox
                name='muted'
                checked={(layer.values.muted as boolean) ?? false}
                onClick={(e) => handleUpdate(layer.id, { muted: e })}
                label='Muted'
              />
            </label>
          </div>
          <div className='text-sm text-red-500 p-3 border border-red-500 bg-gray-700/50 rounded-md flex items-center gap-3 mt-3'>
            <MaterialIcon icon='warning' size={18} />
            <p>
              Users connected through a VPN won&apos;t see your background video. To ensure proper display, select a
              fallback image under the Image tab.
            </p>
          </div>
        </>
      )}
    </div>
  )
}
